module.exports = __webpack_public_path__ + "static/media/phone-pros.799de96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-pros.png
// module id = 1238
// module chunks = 0